var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table-column',{attrs:{"label":"站点","prop":"websiteCode","min-width":"100","align":"center"}})
}
var staticRenderFns = []

export { render, staticRenderFns }